import { useSelector } from 'react-redux';
import type { StatCardConfig } from '../types/totalAnalytics.types';
import { AnalyticsStatCard } from './AnalyticsStatCard';
import { RootState } from '@/shared/store';

type AnalyticsStatsGridProps = {
  cards: StatCardConfig[];
};

export function AnalyticsStatsGrid({ cards }: AnalyticsStatsGridProps) {
  const role = useSelector((state: RootState) => state.auth.user?.role);
  const visibleCards =
    role === 'CLIENT'
      ? cards.filter((card) => card.title !== 'Campaign Cost')
      : cards;

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
      {visibleCards.map((card) => (
        <AnalyticsStatCard key={card.title} {...card} />
      ))}
    </div>
  );
}
